import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, shareReplay, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(false);
  public readonly loading = this._loading.asObservable();

  constructor() {}

  showLoading<T>(obs: Observable<T>): Observable<T> {
    this._loading.next(true);
    return obs.pipe(
      tap(() => {
        this._loading.next(false);
      }),
      catchError((error) => {
        this._loading.next(false);
        return throwError(error);
      }),
      shareReplay()
    );
  }

  show() {
    this._loading.next(true);
  }

  hide() {
    this._loading.next(false);
  }
}
